var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/pages/profile-page.tsx";
import "core-js/modules/es.string.replace.js";
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Redirect, useHistory } from 'react-router-dom';
import { Column, Layout, Tabs } from 'soapbox/components/ui';
import Header from 'soapbox/features/account/components/header';
import LinkFooter from 'soapbox/features/ui/components/link-footer';
import BundleContainer from 'soapbox/features/ui/containers/bundle-container';
import { WhoToFollowPanel, ProfileInfoPanel, ProfileMediaPanel, ProfileFieldsPanel, SignUpPanel, CtaBanner, PinnedAccountsPanel } from 'soapbox/features/ui/util/async-components';
import { useAppSelector, useFeatures, useSoapboxConfig } from 'soapbox/hooks';
import { findAccountByUsername, makeGetAccount } from 'soapbox/selectors';
import { getAcct, isLocal } from 'soapbox/utils/accounts';
const getAccount = makeGetAccount();
/** Page to display a user's profile. */

const ProfilePage = _ref => {
  let {
    params,
    children
  } = _ref;
  const history = useHistory();
  const username = (params === null || params === void 0 ? void 0 : params.username) || '';
  const account = useAppSelector(state => {
    if (username) {
      const account = findAccountByUsername(state, username);

      if (account) {
        return getAccount(state, account.id) || undefined;
      }
    }
  });
  const me = useAppSelector(state => state.me);
  const features = useFeatures();
  const {
    displayFqn
  } = useSoapboxConfig(); // Fix case of username

  if (account && account.acct !== username) {
    return /*#__PURE__*/React.createElement(Redirect, {
      to: "/@".concat(account.acct),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 50,
        columnNumber: 12
      }
    });
  }

  const tabItems = [{
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "account.posts",
      defaultMessage: "Posts",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 55,
        columnNumber: 13
      }
    }),
    to: "/@".concat(username),
    name: 'profile'
  }, {
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "account.posts_with_replies",
      defaultMessage: "Posts and replies",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 60,
        columnNumber: 13
      }
    }),
    to: "/@".concat(username, "/with_replies"),
    name: 'replies'
  }, {
    text: /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "account.media",
      defaultMessage: "Media",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 65,
        columnNumber: 13
      }
    }),
    to: "/@".concat(username, "/media"),
    name: 'media'
  }];

  if (account) {
    const ownAccount = account.id === me;

    if (ownAccount || !account.pleroma.get('hide_favorites', true)) {
      tabItems.push({
        text: /*#__PURE__*/React.createElement(FormattedMessage, {
          id: "navigation_bar.favourites",
          defaultMessage: "Likes",
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 75,
            columnNumber: 15
          }
        }),
        to: "/@".concat(account.acct, "/favorites"),
        name: 'likes'
      });
    }
  }

  let activeItem;
  const pathname = history.location.pathname.replace("@".concat(username, "/"), '');

  if (pathname.endsWith('/with_replies')) {
    activeItem = 'replies';
  } else if (pathname.endsWith('/media')) {
    activeItem = 'media';
  } else if (pathname.endsWith('/favorites')) {
    activeItem = 'likes';
  } else {
    activeItem = 'profile';
  }

  const showTabs = !['/following', '/followers', '/pins'].some(path => pathname.endsWith(path));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Layout.Main, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 98,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Column, {
    label: account ? "@".concat(getAcct(account, displayFqn)) : '',
    withHeader: false,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 99,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "space-y-4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 100,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Header, {
    account: account,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 101,
      columnNumber: 13
    }
  }), /*#__PURE__*/React.createElement(BundleContainer, {
    fetchComponent: ProfileInfoPanel,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 103,
      columnNumber: 13
    }
  }, Component => /*#__PURE__*/React.createElement(Component, {
    username: username,
    account: account,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 104,
      columnNumber: 29
    }
  })), account && showTabs && /*#__PURE__*/React.createElement(Tabs, {
    key: "profile-tabs-".concat(account.id),
    items: tabItems,
    activeItem: activeItem,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 108,
      columnNumber: 15
    }
  }), children)), !me && /*#__PURE__*/React.createElement(BundleContainer, {
    fetchComponent: CtaBanner,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 116,
      columnNumber: 11
    }
  }, Component => /*#__PURE__*/React.createElement(Component, {
    key: "cta-banner",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 117,
      columnNumber: 27
    }
  }))), /*#__PURE__*/React.createElement(Layout.Aside, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 122,
      columnNumber: 7
    }
  }, !me && /*#__PURE__*/React.createElement(BundleContainer, {
    fetchComponent: SignUpPanel,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 124,
      columnNumber: 11
    }
  }, Component => /*#__PURE__*/React.createElement(Component, {
    key: "sign-up-panel",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 125,
      columnNumber: 27
    }
  })), /*#__PURE__*/React.createElement(BundleContainer, {
    fetchComponent: ProfileMediaPanel,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 128,
      columnNumber: 9
    }
  }, Component => /*#__PURE__*/React.createElement(Component, {
    account: account,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 129,
      columnNumber: 25
    }
  })), account && !account.fields.isEmpty() && /*#__PURE__*/React.createElement(BundleContainer, {
    fetchComponent: ProfileFieldsPanel,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 132,
      columnNumber: 11
    }
  }, Component => /*#__PURE__*/React.createElement(Component, {
    account: account,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 133,
      columnNumber: 27
    }
  })), features.accountEndorsements && account && isLocal(account) ? /*#__PURE__*/React.createElement(BundleContainer, {
    fetchComponent: PinnedAccountsPanel,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 137,
      columnNumber: 11
    }
  }, Component => /*#__PURE__*/React.createElement(Component, {
    account: account,
    limit: 5,
    key: "pinned-accounts-panel",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 138,
      columnNumber: 27
    }
  })) : me && features.suggestions && /*#__PURE__*/React.createElement(BundleContainer, {
    fetchComponent: WhoToFollowPanel,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 141,
      columnNumber: 11
    }
  }, Component => /*#__PURE__*/React.createElement(Component, {
    limit: 3,
    key: "wtf-panel",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 142,
      columnNumber: 27
    }
  })), /*#__PURE__*/React.createElement(LinkFooter, {
    key: "link-footer",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 145,
      columnNumber: 9
    }
  })));
};

export default ProfilePage;